var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-contianer"},[_vm._m(0),_c('div',{staticClass:"phone-button",on:{"click":_vm.gotoupdate}},[_vm._v("更新信息")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-title"},[_c('div',{staticClass:"phone-img"},[_c('img',{attrs:{"src":require("../../../assets/user/loginFood.png")}})]),_c('div',{staticClass:"phone-text"},[_c('span',[_vm._v("Hello，欢迎来到试吃团~")])])])
}]

export { render, staticRenderFns }